import React, {useCallback, useEffect, useState} from 'react';
import "./ListProducts.css"
import Grid from "@mui/material/Grid";
import axios from "axios";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import DatePicker from "react-datepicker2";
import Switch from "@mui/material/Switch";
import {strings} from "../../../strings";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import SwipeableViews from "react-swipeable-views";
import Dropzone from "react-dropzone";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {useDispatch, useSelector} from "react-redux";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import {LoadingComponents, ContainerHeader, SortableTableMat} from "../../module";
import separate from "../../functions/separate/separate";
import noContent from "../../../Image/noContent.svg";
import {number} from "prop-types";
import CloseIcon from "@mui/icons-material/Close";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {selToken} from "../../../stores/base/baseSlice";
import {Link, useHistory} from "react-router-dom";
import {makeStyles} from "@mui/styles";
import {TableSortLabel} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from "@mui/material/IconButton";
import {deleteProduct} from "../../../stores/product/thunks";
import ModalAlerterCallback from '../../utils/ModalAlerterCallback';
import debounce from "../../utils/debuce";

const initialState = {
    iSBNBook: "",
    activationOfISBNPeriodicWorks: false,
    periodicISBN: "",
    bookName: "",
    discounted_percent: "",
    description: "",
    bookPrice: "",
    category: "",
};

const styles = {
    tabs: {
        background: '#fff',
    },
    slide: {
        padding: 15,
        minHeight: 100,
        color: '#fff',
    },
};
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'center',
        padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    actions: {
        display: 'flex !important',
        flexDirection: 'row',
        gap: '0 10px'
    },
    editIcon: {
        color: '#FF8C00',
    },
    deleteIcon: {
        color: 'red',
    },
    viewEx: {
        color: '#0054a7',
    },
    item: {
        padding: '16px 8px',
    },
}));


const headCells = [
    {
        id: 'title',
        numeric: false,
        disablePadding: false,
        label: 'عنوان',
    },
    {
        id: 'rial_price',
        numeric: false,
        disablePadding: false,
        label: 'قیمت',
    },
    {
        id: 'cent_price',
        numeric: false,
        disablePadding: false,
        label: 'موجود در انبار',
    },
    {
        id: 'action',
        numeric: false,
        disablePadding: false,
        label: '',
        sort: true,
    },
];

function ListProducts() {
    const options = [
        {
            title: "همه",
            value: "",
            type: 'query'
        },
        {
            title: "عنوان",
            value: {
                q: ""
            },
            type: 'search'
        },
        {
            title: "قیمت",
            value: {
                price: ""
            },
            type: 'search'
        },
        {
            title: "فعال",
            value: "1",
            type: 'query'
        },
        {
            title: "غیر فعال",
            value: "0",
            type: 'query'
        },
        {
            title: "غیر قابل خرید",
            value: "2",
            type: 'query'
        }
    ];

    const dispatch = useDispatch();
    const history = useHistory();
    const [searcher, setSearcher] = useState('');

    const [params, setParams] = useState({
        is_active:'',
        q: '',
    });
    const [value, setValue] = useState(options[0]);
    const [inputValue, setInputValue] = useState('');
    const [dialogForDelete, setDialogForDelete] = useState(false);
    const [searchValue, setSearchValue] = useState('');


    function removeProduct(product_id, refreshTable) {
        const callback = () =>
            dispatch(deleteProduct({product_id}, refreshTable));
        ModalAlerterCallback(callback);
        // dispatch(deleteCoursesAdmin({ course_id }));
    }


    const ExerciseHeadMedel = (props) => {
        const classes = useStyles();
        const {headCell, order, orderBy} = props;

        return (
            <TableCell
                key={headCell.id}
                align={headCell.numeric ? 'right' : 'left'}
                padding={headCell.disablePadding ? 'none' : 'normal'}
                sortDirection={orderBy === headCell.id ? order : false}
            >
                <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : 'asc'}
                    // onClick={createSortHandler(headCell.id)}
                >
                    {headCell.label}
                    {orderBy === headCell.id ? (
                        <span className={classes.visuallyHidden}>
            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
          </span>
                    ) : null}
                </TableSortLabel>
            </TableCell>
        );
    };

    const ExerciseRowTableModel = (props) => {
        const dispatch = useDispatch();
        const history = useHistory();
        const classes = useStyles();
        const {row, onRemove, refreshTable} = props;

        function handleRemove() {
            onRemove(row.id, refreshTable);
        }

        function handleShow() {
            // dispatch(setExModalData(row));
            // onRemove(row.id, refreshTable);
        }

        function handleEdit() {
            // dispatch(setExModalData(row));
            history.push(`/exercises/${row.exercise_id}`);
        }

        return (
            <TableRow hover tabIndex={-1} key={row.id}>
                <TableCell align="left">{row.name}</TableCell>
                <TableCell align="left">{separate(row.price)}</TableCell>
                <TableCell align="left">مقدار</TableCell>
                <TableCell align="left" className={classes.actions}>
                    <Link to={`/product/${row.slug}`}>
                        <Tooltip title="ویرایش">
                            <IconButton>
                                <EditIcon/>
                            </IconButton>
                        </Tooltip>
                    </Link>
                    <div onClick={handleRemove}>
                        <Tooltip title="حذف">
                            <IconButton>
                                <DeleteIcon/>
                            </IconButton>
                        </Tooltip>
                    </div>
                </TableCell>
            </TableRow>
        );
    };

    const debounceSetSearchFor = useCallback(debounce(async function (value,name) {
        setParams((prev) => ({...prev, [name]: value}))

    }, 1000), []);

    async function handleSearch(value, name) {
        debounceSetSearchFor(value, name)
    }

    function addProduct() {
        history.push('/product');
    }


    return (
        <Grid item xs={12} sm={12} className="d-flex flex-column DivParentCreateProduct">
            <ContainerHeader
                data={{
                    filter: false,
                    addBtn: true,
                }}
                headerTitle="لیست محصولات"
                titleBtn="افزودن محصول"
                addBtnAction={addProduct}
                // filterAction={(value) => {
                //     handleSearch(value);
                // }}
            />
            <Paper className="parentBoxSearchListProduct">
                <Grid item xs={12} sm={6} md={5} lg={4}>
                    {params.price === undefined &&
                    <TextField
                        label="عنوان جستجو"
                        variant="outlined"
                        className="titleSearchProduct"
                        size="small"
                        style={{width: '100%'}}
                        onChange={(e) => handleSearch(e.target.value,'q')}
                    />
                    }
                    {params.price !== undefined &&
                    <TextField
                        label="مقدار قیمت"
                        className="titleSearchProduct"
                        variant="outlined"
                        size="small"
                        style={{width: '100%'}}
                        onChange={(e) => handleSearch(e.target.value,'price')}
                    />
                    }
                </Grid>
                <Grid item xs={12} sm={6} md={5} lg={4}>
                    <Autocomplete
                        value={value}
                        onChange={(event, newValue,reason) => {
                            setValue(newValue)
                            if(reason === "selectOption"){
                                if(newValue.type === "query"){
                                    setParams({
                                        ...params,
                                        is_active: newValue.value,

                                    })
                                    setSearcher(newValue.value)
                                }else {
                                    setParams({
                                        is_active: params.is_active,
                                        ...newValue.value
                                    })
                                }
                            }else {
                                setParams({
                                    is_active:'1',
                                    q: '',
                                })

                            }

                        }}
                        // onInputChange={(event, newInputValue) => {
                        //     setInputValue(newInputValue);
                        // }}
                        id="controllable-states-demo"
                        getOptionLabel={(option) => option.title}
                        size="small"
                        options={options}
                        style={{width: '100%'}}
                        renderInput={(params) => <TextField {...params} label="فیلتر  نمایش سطر ( دسته‌بندی )"
                                                            variant="outlined"/>}
                    />
                </Grid>
            </Paper>
            <SortableTableMat
                link={`product`}
                RowComponent={ExerciseRowTableModel}
                HeadCompnent={ExerciseHeadMedel}
                headers={headCells}
                version={2}
                preParams={params}
                onRemove={removeProduct}
            />
        </Grid>
    );
}

export default ListProducts;